var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "800px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "tabs-container  app-main-inner-row",
              staticStyle: { "flex-grow": "1" }
            },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.tab_changeHandler },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      key: 10,
                      attrs: {
                        label: _vm.$t("Message.FileInformation"),
                        name: "fileInfo"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: {
                              width: "100%",
                              "min-width": "650px",
                              flex: "1",
                              padding: "10px",
                              height: "400px"
                            },
                            attrs: {
                              "grid-options": _vm.gridOptions,
                              "grid-params": _vm.gridParams,
                              "column-defs": _vm.columnDefs,
                              "row-data": _vm.rowData,
                              "check-sub-record": false
                            },
                            on: {
                              "update:gridParams": function($event) {
                                _vm.gridParams = $event
                              },
                              "update:grid-params": function($event) {
                                _vm.gridParams = $event
                              },
                              gridReady: function(params) {
                                return (_vm.gridApi = params.api)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      key: 20,
                      attrs: {
                        label: _vm.$t("Message.Thumbnail"),
                        name: "thumbnail"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            height: "400px",
                            "min-width": "650px"
                          }
                        },
                        [
                          _c(
                            "viewer",
                            { attrs: { images: _vm.photoList } },
                            _vm._l(_vm.photoList, function(item, index) {
                              return _c("img", {
                                key: index,
                                staticStyle: { margin: "30px" },
                                attrs: {
                                  src: item.src,
                                  height: "156",
                                  width: "120",
                                  title: item.fileName
                                }
                              })
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    no: "downloadHandler",
                    type: "primary",
                    disabled: !(_vm.activeTabName === "fileInfo")
                  },
                  on: { click: _vm.downloadHandler }
                },
                [_vm._v(_vm._s(_vm.$t("Message.DownloadPhotos")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    no: "sendMailHandler",
                    type: "primary",
                    disabled: !(
                      _vm.job &&
                      _vm.job.lob === "AE" &&
                      _vm.activeTabName === "fileInfo"
                    )
                  },
                  on: { click: _vm.sendMailHandler }
                },
                [_vm._v(_vm._s(_vm.$t("FileHistory.SendEmail")))]
              ),
              _vm.job &&
              _vm.activeTabName === "fileInfo" &&
              !_vm.showUploadFileBtn
                ? _c(
                    "el-button",
                    {
                      attrs: { no: "uploadFileHistory", type: "primary" },
                      on: { click: _vm.uploadFileHistory }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("FileHistory.TransferAllToFileHistory"))
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { no: "cancelHandler" },
                  on: { click: _vm.cancelHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.emailInput.visible
        ? _c("email-input", {
            attrs: {
              visible: _vm.emailInput.visible,
              job: _vm.job,
              source: "pictureViewWindow",
              context: {},
              "is-copy-link": true,
              "send-email-data": _vm.emailInput,
              "send-call-back": _vm.sendCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.emailInput, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }